"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var carousel_1 = require("./carousel");
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var heighAwareComponent_1 = require("./heighAwareComponent");
exports.CarouselAnimator = function (_a) {
    var children = _a.children;
    var _b = react_1.useContext(carousel_1.CarouselContext), current = _b.state.current, goTo = _b.goTo;
    var _c = react_1.useState(0), height = _c[0], setHeight = _c[1];
    var slides = children.map(function (child, i) {
        var isActive = current === i;
        var isLeft = i < current;
        var pos = isLeft
            ? ["translateX(-100%)", "translateX(-70%)"]
            : isActive
                ? ["translateX(-50%)", "translateX(-50%)"]
                : ["translateX(0%)", "translateX(-30%)"];
        var forwardProps = {
            position: "absolute",
            left: "50%",
            onClick: function () { return goTo(i); },
            "aria-hidden": isActive ? undefined : "true",
            style: {
                cursor: isActive ? "initial" : "pointer",
                zIndex: isActive ? 100 : 90 + (current - i * (isLeft ? -1 : 1)),
                transition: "transform 0.5s",
                transform: pos[1] + " scale(" + (isActive ? 1 : 0.8) + ")"
            }
        };
        return (react_1.default.createElement(heighAwareComponent_1.HeightAwareComponent, __assign({ key: "slide-cont-" + i, active: isActive, setHeight: setHeight }, forwardProps), react_1.default.cloneElement(child, __assign({}, forwardProps))));
    });
    return (react_1.default.createElement(creator_ui_1.Box, { as: "ul", height: height }, slides));
};
